import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from '../components/auth/auth-guard.service';
import { LoginComponent } from "./account/login/login.component";
import { DashboardComponent } from "./dashboard/dashboard.component";





const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    // {
    // path: 'home', component: BodyBlockComponent, children: [
    { path: 'dashboard', canActivate: [AuthGuard], component: DashboardComponent },
    // { path: 'employeemaster', component: EmployeeMasterComponent },
    // { path: 'addemployeemaster', component: AddEmployeeMasterComponent },
    // { path: 'routelist', component: RouteListComponent },
    // { path: 'routemaster', component: RouteMasterComponent },
    // { path: 'routelist', redirectTo: 'routelist', pathMatch: 'full' },
    // ]
    // },
    {
        path: '**',
        redirectTo: '/login',
        pathMatch: 'full'
    }
]
@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule]
})
export class AppRoutingModule {

}